import { useContext } from './useContext';
import { FOfferType, offerTypeFromJsonQuery } from '../../../JsonQuery';

export function useOfferType(): FOfferType {
  const { jsonQuery } = useContext();

  return offerTypeFromJsonQuery(jsonQuery);
}
